<div class="project-component">

  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start;">
    <div *ngIf="project">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Project: {{project.name}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 16px;align-items:center;">
      <button mat-raised-button (click)="downloadAsPdf()" style="border-radius: 6px;margin-right: 10px; "
              class="button">
        Download as PDF
      </button>

      <button mat-raised-button (click)="print()" style="border-radius: 6px;margin-right: 10px; "
              class="button">
        Print
      </button>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 10px; margin-bottom: 20px;margin-left: 40px;">
    <div style="line-height: 29px; ">Year:</div>
    <div>
      <p-select [options]="years"
                  [(ngModel)]="year"
                  (onChange)="regroupControlItems()">

      </p-select>
    </div>
    <div style="line-height: 29px; ">Month:</div>
    <div>
      <p-select [options]="months"
                  [(ngModel)]="month"
                  (onChange)="regroupControlItems()">

      </p-select>
    </div>
  </div>

  <p-table [value]="remainingControlItems"
           *ngIf="remainingControlItems && remainingControlItems.length > 0"
           #projectsTable
           [style]="{'font-size': '0.8em'}"
           [paginator]="false"
           sortField="controlItem.complianceAreaControlId"
           rowGroupMode="subheader"
           data-groupField="category"
           expandableRowGroups="true"

           [metaKeySelection]="false" dataKey="controlItem.category"
           (onSort)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
           (onFilter)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
  >

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon *ngIf="col.field=='description'" [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
            *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
            [hidden]="day > maxDay">{{day}}</th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngIf="col.field=='description'"  pInputText type="text" placeholder="⌕"
                 (input)="projectsTable.filter($event.target['value'], col.field, 'contains')">
        </th>
        <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
            *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
            [hidden]="day > maxDay"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr class="ui-widget-header"
          *ngIf="rowGroupMetadata['remainingControlItems'] && rowGroupMetadata['remainingControlItems'][item.controlItem.category].index === rowIndex">
        <td [attr.colspan]="maxDay + 2">
          <a href="#" [pRowToggler]="item">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{item.complianceAreaName}} - {{item.category}}</span>
          </a>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
      <tr>
        <td class="description">{{item.description}}</td>
        <td class="description">{{item.message}}</td>
        <td [ngStyle]="{'width':'10em', 'text-align': 'center', 'position':'relative'}"
            *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
            [ngClass]="item['d'+day]?.color"
            [hidden]="day > maxDay">{{item['d' + day]?.message}}</td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngFor="let partner of assignedNonPartnerUsers">
    <ng-container *ngIf="currentUser.userId == partner.userId">
      <h3>{{partner.fullName}}</h3>
      <p-table [value]="filteredControlItems[partner.userId]"
               #projectsTable
               [paginator]="false"
               sortField="controlItem.complianceAreaControlId"
               rowGroupMode="subheader"
               data-groupField="category"
               expandableRowGroups="true"

               [metaKeySelection]="false" dataKey="controlItem.category"
               (onSort)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
               (onFilter)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
      >

        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon *ngIf="col.field=='description'" [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [hidden]="day > maxDay">{{day}}</th>
          </tr>
          <tr>
            <th *ngFor="let col of cols" [ngSwitch]="col.field">
              <input *ngIf="col.field=='description'"  pInputText type="text" placeholder="⌕"
                     (input)="projectsTable.filter($event.target['value'], col.field, 'contains')">
            </th>
            <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [hidden]="day > maxDay"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header"
              *ngIf="rowGroupMetadata[partner.userId] && rowGroupMetadata[partner.userId][item.controlItem.category].index === rowIndex">
            <td [attr.colspan]="maxDay + 2">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item.complianceAreaName}} - {{item.category}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
          <tr>
            <td class="description">{{item.description}}</td>
            <td class="description">{{item.message}}</td>
            <td [ngStyle]="{'width':'10em', 'text-align': 'center', 'position':'relative'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [ngClass]="item['d'+day]?.color"
                [hidden]="day > maxDay">{{item['d' + day]?.message}}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>

  <div class="splitter" *ngIf="assignedPartnerUsers && assignedPartnerUsers.length">Vendor Users</div>

  <div *ngFor="let partner of assignedPartnerUsers">
    <ng-container *ngIf="currentUser.userId == partner.userId || !isPartnerUser">
      <h3>{{partner.fullName}}</h3>
      <p-table [value]="filteredControlItems[partner.userId]"
               #projectsTable
               [paginator]="false"
               sortField="controlItem.complianceAreaControlId"
               rowGroupMode="subheader"
               data-groupField="category"
               expandableRowGroups="true"

               [metaKeySelection]="false" dataKey="controlItem.category"
               (onSort)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
               (onFilter)="updateRowGroupMetaData(remainingControlItems, 'remainingControlItems')"
      >

        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon *ngIf="col.field=='description'" [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [hidden]="day > maxDay">{{day}}</th>
          </tr>
          <tr>
            <th *ngFor="let col of cols" [ngSwitch]="col.field">
              <input *ngIf="col.field=='description'"  pInputText type="text" placeholder="⌕"
                     (input)="projectsTable.filter($event.target['value'], col.field, 'contains')">
            </th>
            <th [ngStyle]="{'width':'2em', 'white-space': 'nowrap', 'font-size': '12px', 'font-weight': 'bold'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [hidden]="day > maxDay"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header"
              *ngIf="rowGroupMetadata[partner.userId] && rowGroupMetadata[partner.userId][item.controlItem.category].index === rowIndex">
            <td [attr.colspan]="maxDay + 2">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item.complianceAreaName}} - {{item.category}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
          <tr>
            <td class="description">{{item.description}}</td>
            <td class="description">{{item.message}}</td>
            <td [ngStyle]="{'width':'10em', 'text-align': 'center', 'position':'relative'}"
                *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                [ngClass]="item['d'+day]?.color"
                [hidden]="day > maxDay">{{item['d' + day]?.message}}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>

</div>
